<template>
  <div class="card">
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert color="success" v-if="show_success" class="mx-2 mt-2"
        >{{ alert_msg }}
      </argon-alert>
      <div class="table-responsive p-0" v-if="componentiList">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Descrizione
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Stato
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Data creazione
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="componente in componentiList" :key="componente._id">
              <table-row :item="componente" />
              <td class="align-middle">
                <a
                  @click="editComponente(componente._id)"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Modifica"
                  href="javascript:;"
                >
                  <i class="fa fa-pen"></i
                ></a>
                <a
                  @click.stop="openModal(componente._id)"
                  class="text-secondary font-weight-bold text-xs ms-2"
                  data-toggle="tooltip"
                  data-original-title="Elimina"
                  href="javascript:;"
                >
                  <i class="fa fa-trash"></i
                ></a>
                <delete-modal
                  :modalId="'deleteModal' + componente._id"
                  :object="componente"
                  @deleteObject="deleteComponent"
                  @closeModal="closeModal(componente._id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TableRow from "@/components/TableRow.vue";
import router from "@/router";
import DeleteModal from "@/components/deleteModal.vue";
import axios from "axios";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "componenti-table",
  props: {
    componenti: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // pages: {type: Number},
    // total: {type: Number},
    // pagination_size: {type: Number},
  },
  data() {
    return {
      show_success: false,
      alert_msg: "",
      componentiList: {}
    };
  },
  components: { ArgonAlert, DeleteModal, TableRow },
  mounted() {
    this.componentiList = this.componenti;
  },
  methods: {
    editComponente(componenteId) {
      router.push({ name: "componenteedit", params: { id: componenteId } });
    },
    openModal(id) {
      this.$vfm.open("deleteModal" + id);
    },
    async closeModal(id) {
      await router.push({ name: "componenti" });
      await this.$vfm.close("deleteModal" + id);
    },
    async deleteComponent(componente) {
      this.$emit("deleteObject", componente);
      const response = await axios.delete(
        this.$endpoint + "/component/delete/" + componente._id,
        {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        }
      );

      if (response.data.status === "OK") {
        this.show_success = true;
        this.alert_msg = "Componente eliminato con successo";
        const index = this.componentiList.findIndex(obj => obj._id === componente._id) // find the post index
        if (~index) // if the post exists in array
          this.componentiList.splice(index, 1) //delete the post

      }


      await this.closeModal(componente._id);
    },
  },
};
</script>
